/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerCallbacks } from "../../shared/context/PlayerCallbacksContext";
import { usePlayerComponents } from "../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../shared/context/PlayerTranslationContext";
import BackIcon from "../../shared/icons/navigation/Arrow_left.svg";
import { usePlayerFullScreen } from "../Controller";

export const ClosePlayerButtonControl = () => {
  const { onClosePlayer } = usePlayerCallbacks();
  const { Button } = usePlayerComponents();

  const { t } = usePlayerTranslation();
  const label = t("PLAYER_TOOLTIP_CLOSE_PLAYER");

  const onClick = () => onClosePlayer?.();

  return (
    <Button
      variant="tertiary"
      onClick={onClick}
      tooltip={label}
      tooltipAlign="left"
      tooltipOffset={60}
      aria-label={label}
      iconOnly
    >
      <BackIcon aria-hidden="true" focusable="false" />
    </Button>
  );
};

export const ClosePlayerButton = () => {
  const { isFullScreen } = usePlayerFullScreen();

  // do not show button on full screen mode
  if (isFullScreen) {
    return null;
  }

  return <ClosePlayerButtonControl />;
};
